import React from 'react';
import AddForm from '../components/molecules/AddMovieForm';

function MainView() {
  return <AddForm />;
}

export default MainView;
